import CommonJob from '@js/forms/jobManagement/CommonJob.vue'
import CopyMealsToBrand from '@js/forms/jobManagement/CopyMealsToBrand.vue'
import AssignDiscountCodeToClient from '@js/forms/jobManagement/AssignDiscountCodeToClient.vue'
import { NTFY_CZ_SYMBOL, NTFY_DE_SYMBOL } from '@const/common'

export const JOB_TYPES = [
  {
    id: 'CopyMealsToDe',
    name: Translator.trans('job.create.types.copy_meals_to_de'),
    component: CopyMealsToBrand,
    props: {
      brandSymbol: NTFY_DE_SYMBOL,
    }
  },
  {
    id: 'CopyMealsToCz',
    name: Translator.trans('job.create.types.copy_meals_to_cz'),
    component: CopyMealsToBrand,
    props: {
      brandSymbol: NTFY_CZ_SYMBOL,
    }
  },
  {
    id: 'UpdateClientType',
    name: Translator.trans('job.create.types.update_client_type'),
    component: CommonJob,
  },
  {
    id: 'AssignDiscountCodeToClient',
    name: Translator.trans('job.create.types.assign_discount_code_to_client'),
    component: AssignDiscountCodeToClient,
  },
  {
    id: 'AddPointsToClientMoneybox',
    name: Translator.trans('job.create.types.add_points_to_client_moneybox'),
    component: CommonJob,
  },
  {
    id: 'SubtractPointsFromClientMoneybox',
    name: Translator.trans('job.create.types.subtract_points_from_client_moneybox'),
    component: CommonJob,
  },
  {
    id: 'UpdateServingVatRate',
    name: Translator.trans('job.create.types.update_serving_vat_rate'),
    component: CommonJob,
  },
]

export const DISCOUNT_CODE_TYPE_UNIVERSAL = 'UNIVERSAL'
